module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_7016.b722268e.png";